export default "__VITE_ASSET__444b7925__"